module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-27.8cc03651.png";